<template>
  <div>
    <ModalInfo :persistent="isMeasurement && isMeasurementInEdit" :scrollable="true" :layout="'modalEstimate'" :hidden-agree-btn="true" @clicked="hideModalEstimation" :show-modal="isShowEstimationModal" >
      <template v-slot:body>
        <Estimate :isMeasurement="isMeasurement" :isProjectForm="isProjectForm" :key="estimationId"></Estimate>
      </template>
      <template v-slot:actions>
        <div :class="$vuetify.breakpoint.xsOnly ? 'd-flex flex-wrap justify-center' : null">       
        <v-btn
            color="primary"
            :loading="isSavingEstimate || isSavingMeasurement"
            @click="saveEstimateEvent">
        {{ isMeasurement ? languageData.measurements.save_measurement : languageData.labels.save_estimation }}
        </v-btn>
        </div>
      </template>
    </ModalInfo>
    <ModalInfo v-if="isTimeReportSave || isTimeReportUpdate ? true : isShowCreateTimeReportModal" :layout="'modalCreateTimeReport'" :hidden-agree-btn="true" @clicked="hideModalCreateTimeReport" :show-modal="isShowCreateTimeReportModal">
      <template v-slot:body>
        <ProjectTimeReportsForm :projectData="project" :layout="'modalCreateTimeReport'"></ProjectTimeReportsForm>
      </template>
    </ModalInfo>
    <ModalInfo v-if="isShowCreateInvoiceModal" :layout="'modalCreateInvoice'" :hidden-agree-btn="true" @clicked="hideModalCreateInvoice" :show-modal="isShowCreateInvoiceModal">
      <template v-slot:body>
        <Invoice :key="project.id" :projectData="project"></Invoice>
      </template>
    </ModalInfo>
    <ModalInfo
        v-if="isMeasurementInEdit"
        @doOperation="acceptCloseMeasurementFormModal"
        :isLoadingBtn="false"
        :typeInfo="'red'"
        :headModal="languageData.headInfoModalClosing"
        :btnDisAgreeText="languageData.btnStay"
        :btnAgreeText="languageData.btnCloseModal"
        :visDisAgreeBtn="true"
        @clicked="hideCloseMeasurementFormModal"
        :show-modal="showCloseMeasurementFormModal"
        :text-modal="languageData.textInfoModalClosing"></ModalInfo>
  </div>
</template>

<script type="text/javascript">
import { mapActions, mapState } from "vuex";
import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
import Estimate from "../../../Estimate/components/Estimate/Estimate";
import Invoice from "../../../Invoices/components/Invoice/Invoice";
import ProjectTimeReportsForm from "../../../TimeReports/components/ProjectTimeReportsForm/ProjectTimeReportsForm";
import eventBus from "../../../../event-bus/eventBus";

  export default {
    name: "ProjectOperations",
    props: {
      project: Object
    },
    components: {
      ModalInfo,
      Estimate,
      Invoice,
      ProjectTimeReportsForm
    },
    data() {
      return {
        estimationId: 0,
        showCloseMeasurementFormModal: false,
      }
    },
    computed: {
      ...mapState("showEstimationModal", {
        isShowEstimationModal: state => state.isShowEstimationModal,
        isMeasurement: state => state.isMeasurement,
        isMeasurementInEdit: state => state.isMeasurementInEdit,
        isProjectForm: state => state.isProjectForm
      }),
      ...mapState("updateVisibleCreateTimeReportModal", {
        isShowCreateTimeReportModal: state => state.isShowCreateTimeReportModal
      }),
      ...mapState("updateVisibleCreateInvoiceModal", {
        isShowCreateInvoiceModal: state => state.isShowCreateInvoiceModal
      }),
      ...mapState("saveEstimate", {
        isSavingEstimate: state => state.isSaving
      }),
      ...mapState("saveMeasurement", {
        isSavingMeasurement: state => state.isSaving
      }),
      ...mapState("getEstimate", {
        estimationsData: state => state.estimationsData
      }),
       ...mapState("updateTimeReport", {
      isTimeReportUpdate: state => state.isTimeReportUpdate
    }),
    ...mapState("saveProjectReport", {
      isTimeReportSave: state => state.isTimeReportSave,
    }),
    },
    methods: {
      ...mapActions("showEstimationModal", ["updateVisibleEstimationModal", "updateMeasurementEditId", "updateIsProjectForm"]),
      ...mapActions("updateVisibleCreateTimeReportModal", ["updateVisibleCreateTimeReportModal"]),
      ...mapActions("updateVisibleCreateInvoiceModal", ["updateVisibleCreateInvoiceModal"]),
      hideModalEstimation: function() {
        if(this.isMeasurement) {
          if(!this.isMeasurementInEdit) {
            this.updateVisibleEstimationModal(false);
          } else {
            this.showCloseMeasurementFormModal = true;
          }
        } else {
          this.updateVisibleEstimationModal(false);
          this.updateMeasurementEditId(null);
        }
        this.updateIsProjectForm(false);
      },
      acceptCloseMeasurementFormModal() {
        this.updateVisibleEstimationModal(false);
        this.updateMeasurementEditId(null);
      },
      hideCloseMeasurementFormModal() {
        this.showCloseMeasurementFormModal = false;
      },
      hideModalCreateTimeReport: function() {
        this.updateVisibleCreateTimeReportModal(false);
      },
      hideModalCreateInvoice: function() {
        this.updateVisibleCreateInvoiceModal(false);
      },
      addCategoryEvent() {
        eventBus.$emit('addCategory');
      },
      saveEstimateEvent() {
        eventBus.$emit('saveEstimate');
      },
      saveMeasurementEvent() {
        eventBus.$emit('saveMeasurement');
      },
      showOffersList() {
        eventBus.$emit('openOfferListModal');
      }
    },
    mounted() {
      eventBus.$on('importEstimationSuccess', (dataReceive) => {
        this.estimationId = dataReceive.estimation
      });
    }
  }
</script>